import React, { useEffect, useState } from "react";
import Logo from "./../assets/icons/logo.png";
import Food_Drink from "./Food_Drink";
import Arts_Culture from "./Arts_Culture";
import Home_Design from "./Home_Design";
import Hotel_Experiences from "./Hotel_Experiences";
import Non_Profit from "./Non_Profit";
import Retail_More from "./Retail_More";
import FullStory from "./stories/FullStory";
import StoryCard from "./stories/StoryCard";
import { NewNavbar } from "../Pages/NewNavbar";
import localSliderImg2 from "../../../assets/image/1s.png";
import localSliderImg3 from "../../../assets/image/2s.png";
import localSliderImg1 from "../../../assets/image/3s.png";
import localSliderImg4 from "../../../assets/image/story-slider-img-4.webp";
import gridImg1 from "../../../assets/image/grid-img-1.jpg";
import gridImg2 from "../../../assets/image/grid-img-2.jpg";
import gridImg3 from "../../../assets/image/grid-img-3.jpg";
import gridImg4 from "../../../assets/image/grid-img-4.jpg";
import gridImg5 from "../../../assets/image/grid-img-5.jpeg";
import storyImg1 from "../../../assets/image/story-content-img-1.jpg";
import storyImg2 from "../../../assets/image/story-content-img-2.jpg";
import storyImg3 from "../../../assets/image/story-content-img-3.jpg";
import storyImg4 from "../../../assets/image/story-content-img-4.jpg";
import shopIcon from "../../../assets/image/Magazinehomepage_shop_icon.png";
import locationIcon from "../../../assets/image/Magazinehomepage_explore_location_icon.png";
import heartIcon from "../../../assets/image/Magazinehomepage_follow_hart_icon.png";
import searchIcon from "../../../assets/image/Magazinehomepage_discover_search-with-location.png";

import Slider from "react-slick";
import guideLion from "../../../assets/image/lion-watercolor.png";
import lionIcon from "../../../assets/image/1Asset 301@4x.png";
import Footer from "../Footer";
import { fetchStories, fetchStoryById, getImageUrl } from "../../../api/leads";
import { useDispatch, useSelector } from "react-redux";
import SingleCard from "./stories/FilterStory";
import StoriesSlider from "./stories/StoriesSlider";
import { Link } from "react-router-dom";
import FilterStory from "./stories/FilterStory";
import Skeleton from "react-loading-skeleton";
import BottomStory from "./stories/BottomStory";
import YTvideo from "../Components/UI/YTVideo";
import { ToastContainer } from "react-toastify";

interface LocalStories {
  id: number;
  title: string;
  subtitle: string;
  websitee: string | null;
  phone: string | null;
  foldername: string;
  isactive: boolean;
  created_at: string;
}

interface Photo {
  id: number;
  localstoriesid: number;
  photo: string;
  isactive: boolean;
  created_at: string;
}

interface Section {
  id: number;
  localstoriesid: number;
  title: string | null;
  paragraph: string;
  isactive: boolean;
  created_at: string;
}

interface Story {
  localstories: LocalStories;
  photo: Photo[];
  section: Section[];
  location: any;
}

interface Details {
  id: number;
  title: string;
  subtitle: string;
  websitee: string | null;
  phone: string | null;
  foldername: string;
  isactive: boolean;
  created_at: string;
  photos: string[];
  sections: string[];
}

const localStorySlider = {
  className: "center",
  centerMode: true,
  infinite: true,
  slidesToShow: 4.7,
  autoplay: false,
  speed: 500,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3.7,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        CenterMode: false,
      },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
  ],
};

const LocalHome = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);
  const stories = useSelector((state: any) => {
    return state?.stories?.data?.data;
  });

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        await dispatch(fetchStories());
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const idsToExtract = [14, 1, 9, 15];
  // const idSlider = [2, 3, 9, 12, 14, 1, 15];

  const bestStory = !loading
    ? stories.filter((item) => idsToExtract.includes(item.localstories.id))
    : [];
  // const sliderStory = !loading
  //   ? stories.filter((item) => idSlider.includes(item.localstories.id))
  //   : [];
  const reverseArr = [...bestStory].reverse();

  if (error) {
    return <div>{error}</div>;
  }
  return (
    <>
      <NewNavbar />
      <ToastContainer />
      <section className="local-home-banner-section">
        <div className="bg-img-contain"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="main-heading">find your place with</div>
            <div className="milford-text">MILFORD</div>
            <img src={lionIcon} alt="" className="lion-img img-fluid" />
            <div className="sub-heading">This is where local energy lives.</div>
            <div className="sub-content">
              We connect you with the people and businesses that keep our
              community thriving.
            </div>
          </div>
        </div>

        <div className="slider-container container-fluid local-slider-first">
          {loading ? (
            <div className="row">
              <Slider {...localStorySlider}>
                {Array.from({ length: 4 }).map((_, index) => (
                  <div
                    className="col"
                    style={{ display: "contents" }}
                    key={index}
                  >
                    <Skeleton height={465} />
                  </div>
                ))}
              </Slider>
            </div>
          ) : stories?.length > 0 ? (
            <Slider {...localStorySlider}>
              {stories.map((item) => (
                <StoryCard item={item} />
              ))}
            </Slider>
          ) : (
            <h4>No results found</h4>
          )}
        </div>
        <YTvideo />

        {/* lion section start */}
        <div className="lion-section">
          <div className="container">
            <img src={guideLion} alt="" className="lion-img" />
            <div className="content-section">
              <img src={shopIcon} alt="" className="section-icons" />
              <div className="para-content">
                <b>
                  <i> Shop </i>
                </b>
                Local and Support Small Businesses
              </div>
            </div>
            <div className="content-section">
              <img src={locationIcon} alt="" className="section-icons" />
              <div className="para-content">
                <b>
                  <i> Discover </i>
                </b>
                Trends, Finds and Hotspots
              </div>
            </div>
            <div className="content-section">
              <img src={heartIcon} alt="" className="section-icons" />
              <div className="para-content">
                <b>
                  <i> Explore </i>
                </b>
                and Plan your Next Adventure
              </div>
            </div>
            <div className="content-section">
              <img src={searchIcon} alt="" className="section-icons" />
              <div className="para-content">
                <b>
                  <i> Follow Us </i>
                </b>
                for All Things Local
              </div>
            </div>
          </div>
        </div>
        {/* lion section end */}
        <div className="container">
          {loading ? (
            <div className="row">
              {Array.from({ length: 4 }).map((_, index) => (
                <div className="col-lg-3" key={index}>
                  <Skeleton height={465} />
                </div>
              ))}
            </div>
          ) : (
            reverseArr?.length > 0 && <FilterStory filterStory={reverseArr} />
          )}
        </div>
      </section>

      {loading
        ? ""
        : reverseArr?.length > 0 && <BottomStory bottomStory={stories} />}

      <Footer activeSection="local" />
    </>
  );
};

export default LocalHome;
